import OptimizelyFeatureFlagProvider from 'v2/core/clients/featureFlag/optimizely/optimizelyFeatureFlagProvider';
import useGetOptimizelyFeatureFlagManager from 'v2/core/clients/featureFlag/optimizely/useGetOptimizelyFeatureFlagManager';
import useOptimizelyFeatureFlag from 'v2/core/clients/featureFlag/optimizely/useOptimizelyFeatureFlag';

// these are defined in optimizely
export enum Variation {
  On = 'on',
  Off = 'off',
}
export default OptimizelyFeatureFlagProvider;
export { useGetOptimizelyFeatureFlagManager, useOptimizelyFeatureFlag };
